export enum OnboardingBusinessType {
  ECOMMERCE = 'ecommerce',
  LEAD_GEN = 'leadgen',
  SAAS = 'saas',
}
export enum OnboardingPlatform {
  // E-commerce platforms
  SHOPIFY = 'shopify',
  WOOCOMMERCE = 'woocommerce',
  
  // Lead gen platforms
  WORDPRESS = 'wordpress',
  WEBFLOW = 'webflow',
  
  // SaaS platforms
  REACT = 'react',
  
  // Shared
  CUSTOM = 'custom',
}
export enum OnboardingDrawerStep {
  NONE = 'none',
  BUSINESS_TYPE = 'business_type',
  CONFIRM_TIMEZONE = 'confirm_timezone',
  CONNECT_SHOPIFY = 'connect_shopify',
  INSTALL_TRACKING = 'install_tracking',
  CONFIGURE_EVENTS = 'configure_events',
  // Combined selectors for required steps
  SELECT_DATA_SOURCE = 'select_data_source',
  SELECT_DESTINATION = 'select_destination',
  // Individual data source connections
  CONNECT_FACEBOOK_ADS = 'connect_facebook_ads',
  CONNECT_GOOGLE_ADS = 'connect_google_ads',
  CONNECT_TIKTOK_ADS = 'connect_tiktok_ads',
  CONNECT_STRIPE = 'connect_stripe',
  // Individual destination connections
  CONNECT_META_CAPI = 'connect_meta_capi',
  CONNECT_GOOGLE_CAPI = 'connect_google_capi',
  CONNECT_TIKTOK_EVENTS = 'connect_tiktok_events',
  CONNECT_KLAVIYO = 'connect_klaviyo',
  SETUP_COSTS = 'setup_costs',
}
